/** Applies the colors chosen in Settings → Theme. */
export function applyTheme(theme: { primaryColor: string; sidebarColor: string } | null) {
  const root = document.documentElement;
  if (!theme) {
    root.style.removeProperty("--nmt-primary");
    root.style.removeProperty("--nmt-sidebar");
    return;
  }
  root.style.setProperty("--nmt-primary", theme.primaryColor);
  root.style.setProperty("--nmt-sidebar", theme.sidebarColor);
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", theme.sidebarColor);
}
